require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./scribbling-about-what-his-bio-might-be.json") })
        }
      }, "path---scribbling-about-what-his-bio-might-be");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---scribbling-about-what-his-bio-might-be!./.cache/json/scribbling-about-what-his-bio-might-be.json
// module id = 564
// module chunks = 231608221292675